var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 239.194L217.1 223.594L199.2 227.994L211.1 213.894L201.4 198.294L218.5 205.194L230.3 191.094L229 209.494L246.1 216.394L228.2 220.794L226.8 239.194ZM290.6 81.994L280.5 97.394L292.1 111.694L274.4 106.894L264.3 122.394L263.3 103.994L245.6 99.194L262.8 92.594L261.8 74.194L273.4 88.494L290.6 81.994ZM236.2 25.394L234.2 43.694L251 51.294L233 55.094L231 73.394L221.8 57.394L203.9 61.194L216.2 47.494L207 31.594L223.8 39.094L236.2 25.394ZM292.8 161.794L277.9 172.694L283.7 190.194L268.8 179.394L253.9 190.394L259.5 172.794L244.6 162.094L263 161.994L268.6 144.394L274.4 161.894L292.8 161.794ZM115 46.294L132.3 99.794H188.5L143.1 132.694L160.4 186.194L115 153.194L69.5 186.194L86.9 132.694L41.4 99.794H97.7L115 46.294Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.366bac1e5125253f3a33d7f8140e87b6.svg";
export { ForwardRef as ReactComponent };